//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import routes from "routes";
import React, { useState, useEffect } from "react";
//  import ReactGA from "react-ga4";
import { useQuery, useMutation } from "@apollo/client";
// Images

import { Card, CardContent, Button, TextField } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import Box from "@mui/material/Box";
import {
  CREATE_STRATEGYBUDGET,
  FIND_STRATEGYBUDGETS_BY_MUNICIPALITY,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { FormControl, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Budgetopen = ({ selectedKunta, setError, cookies }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  const [amount, setAmount] = useState(10000);
  const [left, setLeft] = useState(10000);
  const [budget, setBudget] = useState([]);
  const [target, setTarget] = useState("");
  const [targetamount, setTargetamount] = useState(0);
  const [name, setName] = useState("");
  const [born, setBorn] = useState("");
  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  const [votes, setVotes] = useState([]);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  ////console.log(token);
  const [budgets, setBudgets] = useState([]);
  const [verified, setVerified] = useState(false);
  // eslint-disable-next-line
  const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  const sbudgetssw = useQuery(FIND_STRATEGYBUDGETS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addbudget)
    }*/
  });
  useEffect(() => {
    let sbudgetss = [];
    //console.log(sbudgetssw);
    //let municipalitiess = [];
    if (sbudgetssw.data) {
      sbudgetss = sbudgetssw.data.findStrategybudgetsByMunicipality;
      //setOrgans(organss);
      //console.log(sbudgetss);
      //let secs = sbudgetss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsbudgets(secs);
      setBudgets(sbudgetss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sbudgetssw]);
  const handleVote = () => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategybudgetid: event,
        userid: cookies.toString(),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategybudgetid === p).length;
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  const [createStrategybudget] = useMutation(CREATE_STRATEGYBUDGET, {
    refetchQueries: [
      { query: FIND_STRATEGYBUDGETS_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  useEffect(() => {
    let sbudgetss = [];
    //console.log(sbudgetssw);
    //let municipalitiess = [];
    if (sbudgetssw.data) {
      sbudgetss = sbudgetssw.data.findStrategybudgetsByMunicipality;
      //setOrgans(organss);
      //console.log(sbudgetss);
      //let secs = sbudgetss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsbudgets(secs);
      setBudgets(sbudgetss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sbudgetssw]);
  useEffect(() => {
    let sum = 0;
    for (let i = 0; i < budget.length; i++) {
      sum = sum + budget[i].amount;
    }
    setLeft(amount - sum);
  }, [amount]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    let txt = "";
    let amo = 0;
    for (let i = 0; i < budget.length; i++) {
      if (i !== 0) {
        txt = txt + ", " + budget[i].name + ": " + budget[i].amount;
        amo = parseInt(amo) + parseInt(budget[i].amount);
      } else {
        txt = budget[0].name + ": " + budget[i].amount;
        amo = parseInt(amo) + parseInt(budget[i].amount);
      }
    }
    createStrategybudget({
      variables: {
        target: txt,
        amount: amo,
        strategydatetime: pvm.toString(),
        municipality: selectedKunta,
        userid: localStorage.getItem("id"),
      },
    });
  };
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    //console.log(token);
    setVerified(!verified);
  }
  const handleRemove = (event) => {
    //console.log(event);
    let amo = budget.filter((cont) => {
      return cont.name === event;
    })[0].amount;
    //console.log(amo);
    let newbud = budget.filter((cont) => {
      return cont.name !== event;
    });
    let le = parseInt(left) + parseInt(amo);
    setLeft(le);
    //console.log(newbud);
    setBudget(newbud);
  };
  const handleAddrow = () => {
    if (targetamount > left) {
      window.confirm("Rahat eivät riitä!");
    } else {
      let newbud = { name: target, amount: targetamount };
      setBudget((budget) => [...budget, newbud]);
      setLeft(left - targetamount);
      //console.log(newbud);
      //setBudget(newbud);
      //console.log(budget);
      setTarget("");
      setTargetamount(0);
    }
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKTypography variant="body1" color="black" textAlign="center" px={{ xs: 6, lg: 12 }} mt={1}>
        <Card style={{ marginBottom: "1rem" }}>
          <CardContent>
            <FormControl style={{ minWidth: 220 }}>
              Syntymävuosi
              <Select
                labelId="born"
                id="born"
                value={born}
                onChange={({ target }) => setBorn(target.value)}
              >
                <MenuItem value={""}>ei valittu</MenuItem>
                <MenuItem value={"2023"}>2023</MenuItem>
                <MenuItem value={"2022"}>2022</MenuItem>
                <MenuItem value={"2021"}>2021</MenuItem>
                <MenuItem value={"2020"}>2020</MenuItem>
                <MenuItem value={"2019"}>2019</MenuItem>
                <MenuItem value={"2018"}>2018</MenuItem>
                <MenuItem value={"2017"}>2017</MenuItem>
                <MenuItem value={"2016"}>2016</MenuItem>
                <MenuItem value={"2015"}>2015</MenuItem>
                <MenuItem value={"2014"}>2014</MenuItem>
                <MenuItem value={"2013"}>2013</MenuItem>
                <MenuItem value={"2012"}>2012</MenuItem>
                <MenuItem value={"2011"}>2011</MenuItem>
                <MenuItem value={"2010"}>2010</MenuItem>
                <MenuItem value={"2009"}>2009</MenuItem>
                <MenuItem value={"2008"}>2008</MenuItem>
                <MenuItem value={"2007"}>2007</MenuItem>
                <MenuItem value={"2006"}>2006</MenuItem>
                <MenuItem value={"2005"}>2005</MenuItem>
                <MenuItem value={"2004"}>2004</MenuItem>
                <MenuItem value={"2003"}>2003</MenuItem>
                <MenuItem value={"2002"}>2002</MenuItem>
                <MenuItem value={"2001"}>2001</MenuItem>
                <MenuItem value={"2000"}>2000</MenuItem>
                <MenuItem value={"1999"}>1999</MenuItem>
                <MenuItem value={"1998"}>1998</MenuItem>
                <MenuItem value={"1997"}>1997</MenuItem>
                <MenuItem value={"1996"}>1996</MenuItem>
                <MenuItem value={"1995"}>1995</MenuItem>
                <MenuItem value={"1994"}>1994</MenuItem>
                <MenuItem value={"1993"}>1993</MenuItem>
                <MenuItem value={"1992"}>1992</MenuItem>
                <MenuItem value={"1991"}>1991</MenuItem>
                <MenuItem value={"1990"}>1990</MenuItem>
                <MenuItem value={"1989"}>1989</MenuItem>
                <MenuItem value={"1988"}>1988</MenuItem>
                <MenuItem value={"1987"}>1987</MenuItem>
                <MenuItem value={"1986"}>1986</MenuItem>
                <MenuItem value={"1985"}>1985</MenuItem>
                <MenuItem value={"1984"}>1984</MenuItem>
                <MenuItem value={"1983"}>1983</MenuItem>
                <MenuItem value={"1982"}>1982</MenuItem>
                <MenuItem value={"1981"}>1981</MenuItem>
                <MenuItem value={"1980"}>1980</MenuItem>
                <MenuItem value={"1979"}>1979</MenuItem>
                <MenuItem value={"1978"}>1978</MenuItem>
                <MenuItem value={"1977"}>1977</MenuItem>
                <MenuItem value={"1976"}>1976</MenuItem>
                <MenuItem value={"1975"}>1975</MenuItem>
                <MenuItem value={"1974"}>1974</MenuItem>
                <MenuItem value={"1973"}>1973</MenuItem>
                <MenuItem value={"1972"}>1972</MenuItem>
                <MenuItem value={"1971"}>1971</MenuItem>
                <MenuItem value={"1970"}>1970</MenuItem>
                <MenuItem value={"1969"}>1969</MenuItem>
                <MenuItem value={"1968"}>1968</MenuItem>
                <MenuItem value={"1967"}>1967</MenuItem>
                <MenuItem value={"1966"}>1966</MenuItem>
                <MenuItem value={"1965"}>1965</MenuItem>
                <MenuItem value={"1964"}>1964</MenuItem>
                <MenuItem value={"1963"}>1963</MenuItem>
                <MenuItem value={"1962"}>1962</MenuItem>
                <MenuItem value={"1961"}>1961</MenuItem>
                <MenuItem value={"1960"}>1960</MenuItem>
                <MenuItem value={"1959"}>1959</MenuItem>
                <MenuItem value={"1958"}>1958</MenuItem>
                <MenuItem value={"1957"}>1957</MenuItem>
                <MenuItem value={"1956"}>1956</MenuItem>
                <MenuItem value={"1955"}>1955</MenuItem>
                <MenuItem value={"1954"}>1954</MenuItem>
                <MenuItem value={"1953"}>1953</MenuItem>
                <MenuItem value={"1952"}>1952</MenuItem>
                <MenuItem value={"1951"}>1951</MenuItem>
                <MenuItem value={"1950"}>1950</MenuItem>
                <MenuItem value={"1949"}>1949</MenuItem>
                <MenuItem value={"1948"}>1948</MenuItem>
                <MenuItem value={"1947"}>1947</MenuItem>
                <MenuItem value={"1946"}>1946</MenuItem>
                <MenuItem value={"1945"}>1945</MenuItem>
                <MenuItem value={"1944"}>1944</MenuItem>
                <MenuItem value={"1943"}>1943</MenuItem>
                <MenuItem value={"1942"}>1942</MenuItem>
                <MenuItem value={"1941"}>1941</MenuItem>
                <MenuItem value={"1940"}>1940</MenuItem>
                <MenuItem value={"1939"}>1939</MenuItem>
                <MenuItem value={"1938"}>1938</MenuItem>
                <MenuItem value={"1937"}>1937</MenuItem>
                <MenuItem value={"1936"}>1936</MenuItem>
                <MenuItem value={"1935"}>1935</MenuItem>
                <MenuItem value={"1934"}>1934</MenuItem>
                <MenuItem value={"1933"}>1933</MenuItem>
                <MenuItem value={"1932"}>1932</MenuItem>
                <MenuItem value={"1931"}>1931</MenuItem>
                <MenuItem value={"1930"}>1930</MenuItem>
                <MenuItem value={"1929"}>1929</MenuItem>
                <MenuItem value={"1928"}>1928</MenuItem>
                <MenuItem value={"1927"}>1927</MenuItem>
                <MenuItem value={"1926"}>1926</MenuItem>
                <MenuItem value={"1925"}>1925</MenuItem>
                <MenuItem value={"1924"}>1924</MenuItem>
                <MenuItem value={"1923"}>1923</MenuItem>
                <MenuItem value={"1922"}>1922</MenuItem>
                <MenuItem value={"1921"}>1921</MenuItem>
                <MenuItem value={"1920"}>1920</MenuItem>
                <MenuItem value={"1919"}>1919</MenuItem>
                <MenuItem value={"1918"}>1918</MenuItem>
                <MenuItem value={"1917"}>1917</MenuItem>
                <MenuItem value={"1916"}>1916</MenuItem>
                <MenuItem value={"1915"}>1915</MenuItem>
                <MenuItem value={"1914"}>1914</MenuItem>
                <MenuItem value={"1913"}>1913</MenuItem>
                <MenuItem value={"1912"}>1912</MenuItem>
                <MenuItem value={"1911"}>1911</MenuItem>
                <MenuItem value={"1910"}>1910</MenuItem>
              </Select>
            </FormControl>
            <FormControl style={{ minWidth: 220 }}>
              Sukupuoli
              <Select
                labelId="gender"
                id="gender"
                value={gender}
                onChange={({ target }) => setGender(target.value)}
                inputProps={{
                  MenuProps: {
                    MenuListProps: {
                      sx: {
                        backgroundColor: "white",
                      },
                    },
                  },
                }}
              >
                <MenuItem value={"ei valitt"}>ei valittu</MenuItem>
                <MenuItem value={"nainen"}>Nainen</MenuItem>
                <MenuItem value={"mies"}>Mies</MenuItem>
                <MenuItem value={"muu"}>Muu</MenuItem>
              </Select>
            </FormControl>
            <FormControl style={{ minWidth: 220 }}>
              Rooli
              <Select
                labelId="role"
                id="role"
                value={role}
                onChange={({ target }) => setRole(target.value)}
              >
                <MenuItem value={""}>ei valittu</MenuItem>
                <MenuItem value={"kuntalainen"}>kuntalainen</MenuItem>
                <MenuItem value={"mökkiläinen"}>mökkiläinen</MenuItem>
                <MenuItem value={"yrittäjä"}>yritys kunnassa</MenuItem>
                <MenuItem value={"ulkokuntalainen"}>ulkokuntalainen</MenuItem>
              </Select>
            </FormControl>
            <br />
            <br />
            <TextField
              label="Nimi"
              value={name}
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              style={{ marginBottom: "0.5rem" }}
            />
            <TextField
              label="Syntymävuosi"
              value={born}
              onChange={(e) => setBorn(e.target.value)}
              variant="outlined"
              style={{ marginBottom: "0.5rem" }}
            />
            <TextField
              label="Sukupuoli"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              variant="outlined"
              style={{ marginBottom: "0.5rem" }}
            />
            <TextField
              label="Rooli"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              variant="outlined"
              style={{ marginBottom: "0.5rem" }}
            />
            <MKTypography variant="h3" gutterBottom>
              {t("budget.header")}
            </MKTypography>
            <MKTypography variant="body1" gutterBottom>
              {t("budget.text")}
            </MKTypography>
            <br />
            {t("budget.whole")}
            <TextField
              label={t("budget.sum")}
              minRows={1}
              value={amount}
              type="Number"
              onChange={(e) => setAmount(e.target.value)}
              variant="outlined"
              style={{ marginBottom: "0.5rem" }}
            />
            <br />
            <br />
            {t("budget.left")}: {left}
            <br />
            <br />
            <Box sx={{ width: "100%" }}>
              <TextField
                label={t("budget.writehere")}
                minRows={1}
                value={target}
                onChange={(e) => setTarget(e.target.value)}
                variant="outlined"
                style={{ marginBottom: "0.5rem" }}
              />
              :
              <TextField
                label={t("budget.targetsum")}
                minRows={1}
                type="number"
                value={targetamount}
                onChange={(e) => setTargetamount(e.target.value)}
                variant="outlined"
                style={{ marginBottom: "0.5rem" }}
              />
              €
              <br />
              <Button variant="contained" style={{ color: "white" }} onClick={handleAddrow}>
                {t("budget.addrow")}
              </Button>
              <br />
              <br />
              <MKTypography
                variant="body1"
                gutterBottom
                style={{ width: "100%", textAlign: "center" }}
              >
                <table style={{ width: "100%", textAlign: "center" }}>
                  {budget.map((item) => (
                    <tr key={item.name}>
                      <td>
                        {item.name} : {item.amount} €
                      </td>
                      <td>
                        <Button
                          variant="contained"
                          style={{ color: "white" }}
                          onClick={() => handleRemove(item.name)}
                        >
                          {t("budget.delete")}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </table>
              </MKTypography>
              <br />
              <br />
              <div style={{ width: "100%", marginLeft: "30%" }}>
                <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
              </div>
              <br />
              <Button
                variant="contained"
                style={{ color: "white" }}
                onClick={handleSubmit}
                disabled={!verified}
                executing={executing}
                submitted={submitted}
              >
                {t("budget.save")}
              </Button>
              <br />
              <br />
            </Box>
          </CardContent>
        </Card>
      </MKTypography>
      <MKTypography variant="h4" gutterBottom>
        {t("budget.saved")}
      </MKTypography>
      {budgets.length === 0 && <MKTypography>{t("budget.nosaved")}</MKTypography>}
      {budgets.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {item.target} | {t("budget.sum")} {item.amount}
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Budgetopen;
